export class Medida {
  id: number;
  medida: string;
  tipo: number;
  ativo: boolean;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/shared/medida.model.ts
 **/